/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2019-01-22 00:22:26
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-22 00:22:48
 */

import _ from "lodash";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "../env/env";
import { ChannelCategory } from "../models/channel-category.model";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { TransService } from "./trans.service";

@Injectable()
export class ChannelCategoryService {
  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/channel-categories`;

  private _categories: BehaviorSubject<ChannelCategory[]> = new BehaviorSubject(
    null
  );

  constructor(private transService: TransService, private http: HttpClient) {}

  createChannelCategory(data) {
    return this.http.post(`${this.url}?lang=${this.transService.lang}`, data);
  }

  getChannelCategories() {
    return this.http.get(`${this.url}?lang=${this.transService.lang}`);
  }

  getChannelCategory(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updateChannelCategory(id: string, data) {
    return this.http.put(
      `${this.url}/${id}?lang=${this.transService.lang}`,
      data
    );
  }

  deleteChannelCategory(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  fetchCategories() {
    this.getChannelCategories().subscribe(res => {
      const categories = res["payload"];
      this.updatedChannelCategories(categories);
    });
  }

  updatedChannelCategories(values) {
    let categories = values;

    if (!categories) categories = this._categories.value;

    if (!categories) return;

    switch (this.transService.lang) {
      case "ja":
        _.each(categories, category => {
          category.nameTrans = category.name_ja || category.name;
        });
        break;
      case "ko":
        _.each(categories, category => {
          category.nameTrans = category.name_ko || category.name;
        });
        break;
      case "cn":
        _.each(categories, category => {
          category.nameTrans = category.name_cn || category.name;
        });
        break;
      default:
        _.each(categories, category => {
          category.nameTrans = category.name;
        });
        break;
    }

    const sortedValues = _.sortBy(categories, category => category.nameTrans);

    this._categories.next([...sortedValues]);
  }

  get channelCategories$() {
    return this._categories.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/services/channel-category.service.ts